var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tournament-ended-label"},[_c('div',{staticClass:"tournament-timer"},[_c('p',{staticClass:"tournament-timer__ended-text"},[_c('span',[_c('i',{staticClass:"fa-regular fa-clock"}),_vm._v(_vm._s(_vm.endedTimerText)+" ")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }